import Vue from 'vue';
import Vuex from 'vuex';

import pathify from './pathify';
// import account from './account';
import account2 from './account2';
import admin from './admin';
import siteAdmin from './siteAdmin';
import { apimAPI } from './apim-api';
import sorting from './sorting';
import browserPerf from './browserPerf';

Vue.use(Vuex);

const modules = {
  // account,
  account2,
  admin,
  siteAdmin,
  apimAPI,
  sorting,
  browserPerf,
};

const store = new Vuex.Store({
  plugins: [pathify.plugin],
  modules,
  strict: process.env.NODE_ENV !== 'production',
});

export default store;
